import { render, staticRenderFns } from "./EnglishLanguageSupport-CN.vue?vue&type=template&id=1c206fb5&scoped=true&"
import script from "./EnglishLanguageSupport-CN.vue?vue&type=script&lang=js&"
export * from "./EnglishLanguageSupport-CN.vue?vue&type=script&lang=js&"
import style0 from "./els-css/typography.gotham.css?vue&type=style&index=0&id=1c206fb5&lang=css&scoped=true&"
import style1 from "./EnglishLanguageSupport-CN.vue?vue&type=style&index=1&id=1c206fb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c206fb5",
  null
  
)

export default component.exports